import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

const languages = ['ro'];
// const languages = ['ro', 'en'];

i18n
  .use(Backend)
  .use(LanguageDetector) //TODO COMMENT LINE TO SHOW ENGLISH VERSION
  .use(initReactI18next)
  .init({
    fallbackLng: 'ro',
    debug: false, //TODO SET TO FALSE TO NOT BE DISPLAYED ON THE CONSOLE
    whitelist: languages,
  });

export default i18n;
